import { Components, Incidents, Templates } from './resources'

export * from './types'

export const StatusPage = {
  Components,
  Incidents,
  Templates,
}
